import {useNavigate} from "react-router-dom";
import React from "react";
import {RezeptManagerComponentModel} from "./RezeptManagerComponentModel";

export const RezeptList  = () => {
    return (
            <RezeptManagerComponentModel/>
    );

}